var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCircleRightArrow = function SvgCircleRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.41 17.417c4.407 0 7.992-3.551 7.992-7.917 0-4.365-3.585-7.917-7.993-7.917-4.407 0-7.992 3.552-7.992 7.917 0 4.366 3.585 7.917 7.992 7.917zM10.41 0C15.697 0 20 4.262 20 9.5S15.698 19 10.41 19C5.12 19 .817 14.738.817 9.5S5.121 0 10.41 0zm3.995 8.708v.04l.8.792-3.157 3.127v-2.375H5.614V8.708h6.434V6.414l2.317 2.294h.04z"
  })));
};

export default SvgCircleRightArrow;